export const DAMAGE_STATUS = {
  DAMAGED: 'SSD001',
  REPAIRED: 'SSD002',
};
